import { ShieldAlert, AlertTriangle } from "lucide-react";

export default function Compliance() {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 py-16">
      <div className="eyebrow">Compliance</div>
      <h1 className="h-display text-4xl md:text-6xl mt-2 leading-[1.04]">Compliance &amp; research-use policy.</h1>

      <div className="mt-6 border border-[var(--line)] bg-[var(--paper-2)] rounded-md p-4 text-[var(--ink-soft)] text-sm leading-relaxed">
        Nebula Aminos supplies reference-grade research compounds and laboratory consumables to accredited laboratories, research institutions, and qualified 21+ researchers only. We are not a consumer brand and we do not sell for human or veterinary use under any circumstance.
      </div>

      <div className="mt-12 space-y-12 text-[var(--ink-soft)]">
        <section>
          <h2 className="font-display text-2xl font-medium text-[var(--ink)]">Research Use Only (RUO)</h2>
          <p className="mt-3 leading-relaxed">
            All Nebula Aminos products are sold strictly for laboratory research use only. They are not for human or animal consumption, and not for use as drugs, food additives, cosmetics, or household chemicals. These products have not been evaluated by the FDA for safety or efficacy.
          </p>
          <div className="mt-4 border border-[var(--line)] bg-[var(--paper-2)] rounded-md p-4 flex items-start gap-3">
            <ShieldAlert className="h-5 w-5 text-[var(--terra)] shrink-0 mt-0.5" />
            <p className="text-sm leading-relaxed">
              By purchasing, you confirm you are 21+ and a qualified researcher, and you accept responsibility for compliance with all applicable laws and regulations.
            </p>
          </div>
        </section>

        <section>
          <h2 className="font-display text-2xl font-medium text-[var(--ink)]">Buyer attestations</h2>
          <p className="mt-3 leading-relaxed">Account-only checkout. Buyer type recorded at sign-up: Laboratory · Research institution · Educational institution · Chemical reseller · Licensed business buyer · Other approved business use. Every order requires per-order attestation: 21+ verification, RUO confirmation, no human use, no veterinary use, no resale for human or veterinary use, terms acceptance with stored version.</p>
        </section>

        <section>
          <h2 className="font-display text-2xl font-medium text-[var(--ink)]">FDA &amp; FTC notice</h2>
          <p className="mt-3 leading-relaxed">
            FDA has not approved Nebula Aminos research compounds for any human or veterinary use. Nebula Aminos does not make, and explicitly disclaims, any therapeutic, diagnostic, preventive, or treatment claim for any product. All advertising follows FTC guidance on health-related claims: truthful, not misleading, and supported by scientific evidence — limited to identity, purity, and analytical methodology.
          </p>
        </section>

        <section>
          <h2 className="font-display text-2xl font-medium text-[var(--ink)]">Per-batch COA</h2>
          <p className="mt-3 leading-relaxed">Every released batch ships with a Koveralabs-verified Certificate of Analysis. COAs are publicly searchable in the COA Hub. Recalled or expired batches are auto-blocked from sale.</p>
        </section>

        <section>
          <h2 className="font-display text-2xl font-medium text-[var(--ink)]">Order review</h2>
          <p className="mt-3 leading-relaxed">All orders enter a brief compliance review queue before release. Triggers include high-risk SKUs, large quantities, new accounts, personal-email domains, residential shipping, and billing/shipping mismatches. No real-time payment capture occurs until release.</p>
        </section>

        <section>
          <h2 className="font-display text-2xl font-medium text-[var(--ink)]">Audit logging</h2>
          <p className="mt-3 leading-relaxed">Every product, COA, article, and order action is recorded in an append-only audit log with actor, timestamp, before/after state, and meta. The audit log is the system of record.</p>
        </section>

        <section>
          <h2 className="font-display text-2xl font-medium text-[var(--ink)]">Refusal of sale</h2>
          <p className="mt-3 leading-relaxed">Nebula Aminos reserves the right to refuse any order or cancel any account that violates the research-use attestations or appears to indicate intended human or veterinary use. Reconstituted products are non-returnable.</p>
        </section>
      </div>
    </div>
  );
}
